/// Parse time string ("HH:mm:ss") into an object with hour, minute, and second properties
/// suitable for use with the luxon DateTime.fromObject() method.
/// @param time The time string to parse
/// @returns An object with hour, minute, and second properties
export function parseTime(time: string): { hour: number, minute: number, second: number } {
    if (!time || !time.match(/^\d?\d:\d{2}(:\d{2})?(\.\d+)?$/))
        return { hour: 0, minute: 0, second: 0 };

    const parts = time.split(':');
    return {
        hour: parseInt(parts[0], 10),
        minute: parseInt(parts[1], 10),
        second: parts[2] ? parseFloat(parts[2]) : 0
    };
}

export function parseDuration(duration: string): { hours: number, minutes: number, seconds: number } {
    const time = parseTime(duration);

    return {
        hours: time.hour,
        minutes: time.minute,
        seconds: time.second
    };
}
